var ko = require('knockout'),
  cart = require('_components/organisms/shopping-cart/shopping-cart-storage');

function Model(params) {
  var self = this;
  self.text = params.text;
  self.addedText = params.addedText;
  self.course = params.course;
  self.isCompact = params.isCompact;
  self.isPurchased = ko.observable(
    cart.findCourseInCart(cart.getCart(), self.course.Id) ? true : false
  );
  self.isInArticle = ko.observable(params.isInArticle);
  self.courseId = null;
  self.purchase = function() {
    if (self.isPurchased()) return;

    self.isPurchased(true);
    self.courseId = params.course.Id;
    cart.addCourseToCart(params.course, params.pageTypeName);
  };

  // Set isPurchased to false when receiving a course that matches 'params.course' on the 'removeCourse' topic.
  ko.postbox.subscribe(
    'removeCourse',
    function(course) {
      if (course.Id === this.courseId) {
        this.isPurchased(false);
      }
      if (self.isInArticle()) {
        this.isInArticle(true);
      }
    },
    this,
    true
  );
}

module.exports = Model;
